import React from 'react'
import uuid from 'uuid/v1'
import { createMarkup } from '../../helpers/bookPrint';

export default function LessonSection({ lessonTitle, sectionContent }) {

   return (
      <div className='lesson-section'>

         <h1>{lessonTitle}</h1>

         {sectionContent.map(section =>
            section.itemType === 'Content' ?
            <div
               key={uuid()}
               className='lesson-content'
               dangerouslySetInnerHTML={createMarkup(section.lessonText)}
            />
            : null
         )}

      </div>
   )
}





// WEBPACK FOOTER //
// ./src/components/BookPrint/LessonSection.js